function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from "@sentry/core";
import { useEffect, useState } from "react";
import { Modal } from "./Modal";
import { Text } from "./Text";
import { View } from "./View";
import { getVTTTranscript } from "../lib/vtt";
/**
 * Retrieves a VTT transcript file from the given uri and displays it as a
 * human-readable transcript inside of a modal element.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-117}
 */ export function TranscriptModal(props) {
    var _useState = _sliced_to_array(useState([]), 2), transcript = _useState[0], setTranscript = _useState[1];
    useEffect(function() {
        getVTTTranscript(props.uri).then(setTranscript).catch(function(e) {
            setTranscript([
                'Something went wrong'
            ]);
            Sentry.captureException(e);
        });
    }, [
        props.uri
    ]);
    var _props_heading;
    return /*#__PURE__*/ _jsx(Modal, {
        visible: true,
        heading: (_props_heading = props.heading) !== null && _props_heading !== void 0 ? _props_heading : 'Transcript',
        onRequestClose: props.onRequestClose,
        maxHeight: 500,
        children: /*#__PURE__*/ _jsx(View, {
            spacing: 16,
            children: transcript.map(function(str, i) {
                return /*#__PURE__*/ _jsx(Text, {
                    text: str
                }, i.toString());
            })
        })
    });
}
